import { useQuery, useMutation } from "@apollo/client/react"

import { useFeatureFlags } from "@/contexts/feature_flags_context"
import {
  GetVenueFullDocument,
  GetAppConfigDocument,
  UpdateReservationRuleSectionsDocument,
  UpdateVenueDocument,
  type GetVenueFullQuery,
  type GetVenueFullQueryVariables,
  type GetAppConfigQuery,
  type UpdateVenueMutation,
  type UpdateVenueMutationVariables,
  type UpdateReservationRuleSectionsMutation,
  type UpdateReservationRuleSectionsMutationVariables,
} from "@/graphql/graphql"

export const useTabbioData = (venueSlug: string | undefined) => {
  const { data, loading, error, refetch } = useQuery<GetVenueFullQuery, GetVenueFullQueryVariables>(
    GetVenueFullDocument,
    { variables: { slug: venueSlug } },
  )
  const { customSectionsEnabled } = useFeatureFlags()
  const { data: appConfigData } = useQuery<GetAppConfigQuery>(GetAppConfigDocument)

  const [updateVenueMutation, { loading: saving }] = useMutation<UpdateVenueMutation, UpdateVenueMutationVariables>(
    UpdateVenueDocument,
  )
  const [updateReservationRuleSectionsMutation, { loading: savingSections }] = useMutation<
    UpdateReservationRuleSectionsMutation,
    UpdateReservationRuleSectionsMutationVariables
  >(UpdateReservationRuleSectionsDocument)

  return {
    venue: data?.venue,
    loading,
    error,
    refetch,
    customSectionsEnabled,
    googleMapsApiKey: appConfigData?.appConfig?.googleMapsApiKey,
    saving,
    savingSections,
    updateVenueMutation,
    updateReservationRuleSectionsMutation,
  }
}
